import axios from "axios";
import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { BASE_URL } from "../../utils/Constants";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const paymentIntent = searchParams.get("payment_intent");
    const token = localStorage.getItem("Token");

    if (paymentIntent&& token) {
      axios
        .get(
          `${BASE_URL}/v1/user/verify-payment?paymentIntentId=${paymentIntent}`,
          {
            headers: {
              Authorization: token,
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            console.info("Payment verified:", res.data);
          } else {
            console.warn("Payment not successful:", res.data.message);
          }
        })
        .catch((err) => {
          console.error("Error verifying payment:", err);
        });
    }
  }, []);

  return (
    <div className="pt-5 pb-4">
      <div
        className="subscription-success-container"
        style={{ minHeight: "60vh", flexDirection: "column" }}
      >
        <div className="success-box">
          <h2 className="success-title">Payment Successful!</h2>
          <p className="success-message">
            Thank you for booking a nanny with us! Your reservation has been
            received, and we’re waiting for the nanny to accept the booking. If
            she’s unavailable, we’ll promptly arrange another suitable nanny for
            you. We appreciate your trust in our service!
          </p>

          <div className="success-actions">
            <Link to="/profile" className="btna btn-primarya">
              Go to Profile
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
